import React, { useState, useEffect } from "react";
import CircularProgress from "@material-ui/core/CircularProgress"
import {CenteredCircle} from "../styles/sharedComponentStyles"
import {Fade} from "@material-ui/core";

const WAKEUP_MESSAGES = [
    "Server was asleep",
    "Server is warming up",
    "This may take a while ...",
    "Still working on it ...",
    "Almost there, hang tight ...",
];

const MESSAGE_DELAY_MS = 10000;
const MESSAGE_INTERVAL_MS = 10000;

export default function LoadingIcon() {

    const [messageIndex, setMessageIndex] = useState(-1); // -1 = nothing shown yet

    useEffect(() => {
        const timers = WAKEUP_MESSAGES.map((_, i) =>
            setTimeout(
                () => setMessageIndex(i),
                MESSAGE_DELAY_MS + MESSAGE_INTERVAL_MS * i
            )
        );

        return () => timers.forEach(clearTimeout);
    }, []);

    return (
        <CenteredCircle>
            <CircularProgress size={70} />
            <Fade in={messageIndex >= 0} timeout={700}>
                <span>{messageIndex >= 0 ? WAKEUP_MESSAGES[messageIndex] : ''}</span>
            </Fade>
        </CenteredCircle>
    );
}